var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"node-hover-onboarding-controls-buttons__button",on:{"click":_vm.replaceSection}},[_c('Icon',{attrs:{"icon":"ArrowsRotateSolidIcon","size":"14"}}),_vm._v(" Shuffle ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }